
const ApiConstants = {
     contactUsUrl: 'api/ba-code/contact-us',
     hiringUrl: 'api/ba-code/hiring',
     fileStorageUrl: "api/file-storage/file-storage",
     getAllPositionUrl: 'api/ba-code/get-all-hiring-designation',
  };
  
  export default ApiConstants;
  